/** @file GENERATED by pnpm gen; do not edit. */
import { command as e0 } from './animation/create.command';
import { command as e1 } from './animation/delete.command';
import { command as e2 } from './animation/deleteKeys.command';
import { command as e3 } from './animation/duplicate.command';
import { command as e4 } from './animation/mirrorAnimation.command';
import { command as e5 } from './animation/moveKeys.command';
import { command as e6 } from './animation/rename.command';
import { command as e7 } from './animation/setCurve.command';
import { command as e8 } from './animation/setDeformKey.command';
import { command as e9 } from './animation/setDrawOrderKey.command';
import { command as e10 } from './animation/setDuration.command';
import { command as e11 } from './animation/setEventKey.command';
import { command as e12 } from './animation/setKey.command';
import { command as e13 } from './animation/setMixDefault.command';
import { command as e14 } from './attachment/createMesh.command';
import { command as e15 } from './attachment/createRegion.command';
import { command as e16 } from './attachment/delete.command';
import { command as e17 } from './attachment/rename.command';
import { command as e18 } from './attachment/setHandle.command';
import { command as e19 } from './attachment/setImage.command';
import { command as e20 } from './attachment/setTransform.command';
import { command as e21 } from './autorig/applyPlan.command';
import { command as e22 } from './bone/create.command';
import { command as e23 } from './bone/delete.command';
import { command as e24 } from './bone/mirrorSelection.command';
import { command as e25 } from './bone/rename.command';
import { command as e26 } from './bone/reorderChildren.command';
import { command as e27 } from './bone/setInherit.command';
import { command as e28 } from './bone/setLength.command';
import { command as e29 } from './bone/setParent.command';
import { command as e30 } from './bone/setTransform.command';
import { command as e31 } from './bone/split.command';
import { command as e32 } from './direction/setCount.command';
import { command as e33 } from './direction/setFix.command';
import { command as e34 } from './direction/setLayout4.command';
import { command as e35 } from './direction/setMode.command';
import { command as e36 } from './direction/syncIso.command';
import { command as e37 } from './event/create.command';
import { command as e38 } from './event/delete.command';
import { command as e39 } from './event/rename.command';
import { command as e40 } from './event/setDefaults.command';
import { command as e41 } from './ik/create.command';
import { command as e42 } from './ik/delete.command';
import { command as e43 } from './ik/set.command';
import { command as e44 } from './ik/setKey.command';
import { command as e45 } from './image/delete.command';
import { command as e46 } from './image/importLayers.command';
import { command as e47 } from './image/register.command';
import { command as e48 } from './image/rename.command';
import { command as e49 } from './mesh/rebindMesh.command';
import { command as e50 } from './mesh/setBinding.command';
import { command as e51 } from './mesh/setHull.command';
import { command as e52 } from './mesh/setMirrorVertexMap.command';
import { command as e53 } from './mesh/setTriangles.command';
import { command as e54 } from './mesh/setVertexWeights.command';
import { command as e55 } from './mesh/setVertices.command';
import { command as e56 } from './mesh/setWeights.command';
import { command as e57 } from './mesh/smoothWeights.command';
import { command as e58 } from './project/rename.command';
import { command as e59 } from './project/replaceDoc.command';
import { command as e60 } from './project/restore.command';
import { command as e61 } from './project/setFps.command';
import { command as e62 } from './project/setView.command';
import { command as e63 } from './project/trash.command';
import { command as e64 } from './reference/add.command';
import { command as e65 } from './reference/remove.command';
import { command as e66 } from './reference/setTransform.command';
import { command as e67 } from './skin/create.command';
import { command as e68 } from './skin/delete.command';
import { command as e69 } from './skin/removeEntry.command';
import { command as e70 } from './skin/rename.command';
import { command as e71 } from './skin/setDefault.command';
import { command as e72 } from './skin/setEntry.command';
import { command as e73 } from './slot/create.command';
import { command as e74 } from './slot/delete.command';
import { command as e75 } from './slot/rename.command';
import { command as e76 } from './slot/setAttachment.command';
import { command as e77 } from './slot/setBlend.command';
import { command as e78 } from './slot/setBone.command';
import { command as e79 } from './slot/setColor.command';
import { command as e80 } from './slot/setDrawOrder.command';
import { command as e81 } from './socket/create.command';
import { command as e82 } from './socket/delete.command';
import { command as e83 } from './socket/equip.command';
import { command as e84 } from './socket/setPoints.command';
import { command as e85 } from './socket/unequip.command';
export const COMMANDS = [e0, e1, e2, e3, e4, e5, e6, e7, e8, e9, e10, e11, e12, e13, e14, e15, e16, e17, e18, e19, e20, e21, e22, e23, e24, e25, e26, e27, e28, e29, e30, e31, e32, e33, e34, e35, e36, e37, e38, e39, e40, e41, e42, e43, e44, e45, e46, e47, e48, e49, e50, e51, e52, e53, e54, e55, e56, e57, e58, e59, e60, e61, e62, e63, e64, e65, e66, e67, e68, e69, e70, e71, e72, e73, e74, e75, e76, e77, e78, e79, e80, e81, e82, e83, e84, e85] as const;
